import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'contract_not_found.title',
  },
  subTitle: {
    id: 'contract_epargn_not_found.sub_title',
  },
  nextLabel: {
    id: 'auth_by_contract_epargn_failed.next_label',
  },
  previousLabel: {
    id: `auth_by_contract_failed.previous_label`,
  },
  agentLocation: {
    id: `auth_by_contract_failed.agent_location`,
  },
  helpMessage: {
    id: `auth_by_contract_epargn_failed.help_message`,
  },
  need_help: {
    id: `info_numero_police.header`,
  },
});
